// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tSUz","content":"styles_content__1q2VA"};